export const IconBars = {
  name: 'icon-bars',
  template: `
    <svg class="icon icon-bars" width="24" height="24" viewBox="0 0 24 24">
      <rect x="3" y="11" width="18" height="2"/>
      <rect x="3" y="4" width="18" height="2"/>
      <rect x="3" y="18" width="18" height="2"/>
    </svg>
  `
}

export const IconCross = {
  name: 'icon-cross',
  template: `
    <svg class="icon icon-cross" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="13.41 12 20.36 18.95 18.95 20.36 12 13.41 5.05 20.36 3.64 18.95 10.59 12 3.64 5.05 5.05 3.64 12 10.59 18.95 3.64 20.36 5.05 13.41 12"/>
    </svg>
  `
}

export const IconPlus = {
  name: 'icon-plus',
  template: `
    <svg class="icon icon-plus" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="20 11 20 13 13 13 13 20 11 20 11 13 4 13 4 11 11 11 11 4 13 4 13 11 20 11"/>
    </svg>
  `
}

export const IconDownArrow = {
  name: 'icon-down-arrow',
  template: `
    <svg class="icon icon-down-arrow" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="12 15.18 5.05 8.23 3.64 9.64 12 18 20.36 9.64 18.95 8.23 12 15.18"/>
    </svg>
  `
}

export const IconLeftArrow = {
  name: 'icon-left-arrow',
  template: `
    <svg class="icon icon-left-arrow" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="8.82 12 15.77 18.95 14.36 20.36 6 12 14.36 3.64 15.77 5.05 8.82 12"/>
    </svg>
  `
}

export const IconRightArrow = {
  name: 'icon-right-arrow',
  template: `
    <svg class="icon icon-right-arrow" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="15.18 12 8.23 18.95 9.64 20.36 18 12 9.64 3.64 8.23 5.05 15.18 12"/>
    </svg>
  `
}

export const IconDownload = {
  name: 'icon-download',
  template: `
    <svg class="icon icon-download" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="21 15 21 21 3 21 3 15 5 15 5 19 19 19 19 15 21 15"/>
      <polygon points="18.71 9.71 12 16.42 5.29 9.71 6.71 8.29 11 12.58 11 2 13 2 13 12.58 17.29 8.29 18.71 9.71"/>
    </svg>
  `
}

export const IconReplay = {
  name: 'icon-replay',
  template: `
    <svg class="icon icon-replay" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="9 18 9 6 17 12 9 18"/>
      <path d="M20.49,20.49a12.06,12.06,0,0,1-16.63.34L2,22.7V17.55H7.14L5.28,19.41A10,10,0,1,0,12,2V0a12,12,0,0,1,8.49,20.48Z"/>
    </svg>
  `
}

export const IconPlay = {
  name: 'icon-play',
  template: `
    <svg class="icon icon-play" width="24" height="24" viewBox="0 0 24 24">
      <polygon points="7 19 7 5 19 12 7 19"/>
    </svg>
  `
}

export const IconTouch = {
  name: 'icon-touch',
  template: `
    <svg class="icon icon-touch" width="48" height="48" viewBox="0 0 48 48">
      <path d="M32.53,22.87a1.94,1.94,0,0,0-1.87,1.43v-.73a1.94,1.94,0,0,0-3.81-.5v-.84a1.92,1.92,0,0,0-3.78-.47V13.59a1.94,1.94,0,0,0-2-2,2,2,0,0,0-2,2V26.22C17.56,24.58,15.78,23,14.45,23a1.44,1.44,0,0,0-1.16.49c-.78.93.15,2.05,1.27,3.52a32.84,32.84,0,0,1,3,5.79c1.18,2.51,2.22,3.81,2.22,5.6V39H32.63c0-2.46,1.84-3.7,1.84-7.31V24.8a1.94,1.94,0,0,0-1.95-1.93"/>
      <path d="M17,13.67a4.16,4.16,0,0,1,4-4.11,4.22,4.22,0,0,1,4,4.18v3.88a7.54,7.54,0,0,0,2-4.69,5.78,5.78,0,0,0-6.07-6,5.74,5.74,0,0,0-6,6,7.26,7.26,0,0,0,2,4.69Z"/>
    </svg>
  `
}

export const IconSwipe = {
  name: 'icon-swipe',
  template: `
    <svg class="icon icon-swipe" width="48" height="48" viewBox="0 0 48 48">
      <path d="M32.53,22.87a1.94,1.94,0,0,0-1.87,1.43v-.73a1.94,1.94,0,0,0-3.81-.5v-.84a1.92,1.92,0,0,0-3.78-.47V13.59a1.94,1.94,0,0,0-2-2,2,2,0,0,0-2,2V26.22C17.56,24.58,15.78,23,14.45,23a1.44,1.44,0,0,0-1.16.49c-.78.93.15,2.05,1.27,3.52a32.84,32.84,0,0,1,3,5.79c1.18,2.51,2.22,3.81,2.22,5.6V39H32.63c0-2.46,1.84-3.7,1.84-7.31V24.8a1.94,1.94,0,0,0-1.95-1.93"/>
      <polygon points="33.41 14 28.71 18.71 27.29 17.29 29.59 15 24 15 24 13 29.59 13 27.29 10.71 28.71 9.29 33.41 14"/>
      <polygon points="8.59 14 13.29 9.29 14.71 10.71 12.41 13 18 13 18 15 12.41 15 14.71 17.29 13.29 18.71 8.59 14"/>
    </svg>
  `
}

export const IconUpArrowLarge = {
  name: 'icon-up-arrow-large',
  template: `
    <svg class="icon icon-up-arrow-large" width="48" height="48" viewBox="0 0 48 48">
      <polygon points="24 13.59 39.71 29.29 38.29 30.71 24 16.41 9.71 30.71 8.29 29.29 24 13.59"/>
    </svg>
  `
}

export const IconDownArrowLarge = {
  name: 'icon-down-arrow-large',
  template: `
    <svg class="icon icon-down-arrow-large" width="48" height="48" viewBox="0 0 48 48">
      <polygon points="24 34.41 8.29 18.71 9.71 17.29 24 31.59 38.29 17.29 39.71 18.71 24 34.41"/>
    </svg>
  `
}

export const IconCable = {
  name: 'icon-cable',
  template: `
    <svg class="icon icon-cable" width="42" height="42" viewBox="0 0 42 42">
      <path d="M19.2,21.62h2.68l-1.46,3.7a.62.62,0,0,0,.35.8.63.63,0,0,0,.23,0,.62.62,0,0,0,.58-.39l1.8-4.55a.62.62,0,0,0-.58-.85H20.11l1.46-3.7a.62.62,0,1,0-1.15-.45l-1.8,4.55a.62.62,0,0,0,.58.85"/>
      <path d="M41.14,12H38.21V9.66h2.93a.74.74,0,1,0,0-1.49H38.21V6.73a.74.74,0,1,0-1.49,0v.21H33.91a2.6,2.6,0,0,0-2.42,1.52h-.6a.74.74,0,0,0-.74.74v.89H21a10.9,10.9,0,0,0-5.49,20.33H11.85v-.89a.74.74,0,0,0-.74-.74h-.6a2.6,2.6,0,0,0-2.42-1.52H5.28v-.22a.74.74,0,0,0-1.49,0V28.5H.86A.74.74,0,0,0,.86,30H3.8v2.34H.86a.74.74,0,1,0,0,1.49H3.8v1.45a.74.74,0,0,0,1.49,0v-.21H8.09a2.6,2.6,0,0,0,2.42-1.52h.6a.74.74,0,0,0,.74-.74v-.89H21a10.9,10.9,0,0,0,5.49-20.33h3.66v.89a.74.74,0,0,0,.74.74h.6a2.6,2.6,0,0,0,2.42,1.52h2.81v.21a.74.74,0,0,0,1.49,0V13.5h2.93a.74.74,0,0,0,0-1.49ZM36.72,8.43v4.82H33.91a1.05,1.05,0,0,1-1.11-.85.74.74,0,0,0-.74-.67h-.43V10h.43a.74.74,0,0,0,.74-.67,1.05,1.05,0,0,1,1.11-.85ZM30.42,21A9.42,9.42,0,1,1,21,11.58,9.43,9.43,0,0,1,30.42,21ZM10.37,30.28v1.77H9.94a.74.74,0,0,0-.74.67,1,1,0,0,1-1.11.85H5.28V28.75H8.09a1.05,1.05,0,0,1,1.11.85.74.74,0,0,0,.74.67Z"/>
      <path d="M34.86,9.4a.62.62,0,0,0-.62.62v1.61a.62.62,0,0,0,1.24,0V10a.62.62,0,0,0-.62-.62"/>
      <path d="M7.14,29.75a.62.62,0,0,0-.62.62V32a.62.62,0,1,0,1.24,0V30.37a.62.62,0,0,0-.62-.62"/>
      <path d="M21,13.92A7.08,7.08,0,1,1,13.92,21,7.09,7.09,0,0,1,21,13.92m0,15.4A8.32,8.32,0,1,0,12.68,21,8.33,8.33,0,0,0,21,29.32"/>
    </svg>
  `
}

export const IconNetwork = {
  name: 'icon-network',
  template: `
    <svg class="icon icon-network" width="42" height="42" viewBox="0 0 42 42">
      <path d="M16.34,19.26a1.64,1.64,0,1,1-1.64-1.64,1.71,1.71,0,0,1,1.64,1.64M6.22,34.43a1.67,1.67,0,0,1-1.64,1.64,1.63,1.63,0,0,1-1.64-1.64,1.67,1.67,0,0,1,1.64-1.64,1.67,1.67,0,0,1,1.64,1.64M37.48,9.28a1.64,1.64,0,1,1,1.64-1.64,1.77,1.77,0,0,1-1.64,1.64m-8,17.08a1.64,1.64,0,1,1-3.28,0,1.64,1.64,0,1,1,3.28,0m8-23.18A4.47,4.47,0,0,0,33,7.64a4.42,4.42,0,0,0,1.31,3.15L28.88,22a4.4,4.4,0,0,0-4.07,1.05l-5.71-3a3.47,3.47,0,0,0,.07-.85,4.47,4.47,0,1,0-8.27,2.3L5.7,30.09a6.67,6.67,0,0,0-1.12-.2A4.47,4.47,0,1,0,9,34.37a4.32,4.32,0,0,0-.92-2.69l5.06-8.27a3.94,3.94,0,0,0,1.58.26,4.35,4.35,0,0,0,3-1.12l5.78,3a3,3,0,0,0-.07.79,4.47,4.47,0,1,0,7.88-2.83L36.89,12.1h.53a4.47,4.47,0,0,0,.07-8.93"/>
    </svg>
  `
}

export const IconPeople = {
  name: 'icon-people',
  template: `
    <svg class="icon icon-network" width="42" height="42" viewBox="0 0 42 42">
      <path d="M26.47,26.77A6.87,6.87,0,0,1,28,28v1.92H14V28a12.25,12.25,0,0,1,1.87-1.49c.53-.38,1.11-.72,1.68-1.05a17.61,17.61,0,0,1,1.92-1,1.18,1.18,0,0,0,.72-1,1.16,1.16,0,0,0-.53-1.05,2.9,2.9,0,0,1-1.44-2.44V17.14a2.88,2.88,0,0,1,5.76,0v2.92a2.8,2.8,0,0,1-1.49,2.49,1.13,1.13,0,0,0-.57,1,1,1,0,0,0,.67,1c.43.19,1.25.62,2.16,1.15.62.38,1.2.77,1.73,1.1m-.24-6.71V17.14a5.09,5.09,0,0,0-10.17,0v2.92a5.09,5.09,0,0,0,1.1,3.16c-.43.24-.91.48-1.39.77l-.72.43c-.43.29-.82.53-1.11.77-1.87,1.34-2.16,2.06-2.16,2.68V31a1.09,1.09,0,0,0,1.11,1.1H29.06A1.09,1.09,0,0,0,30.17,31V27.87a3.58,3.58,0,0,0-1.63-2.3A26.27,26.27,0,0,0,26.33,24c-.48-.29-.91-.53-1.34-.77a4.65,4.65,0,0,0,1.25-3.21"/>
      <path d="M5.74,26.58c-.1-.34-.24-.67-.34-1a7.63,7.63,0,0,1,.34,1m31.09-2a2.64,2.64,0,0,0-.62-.34l-.1,0a1.14,1.14,0,0,0,.34-.34,1,1,0,0,0,0-1,7.79,7.79,0,0,1-.72-2.44l-.1-2A4.5,4.5,0,0,0,31.32,14h0A4.46,4.46,0,0,0,27,17.76v2.3A6,6,0,0,1,26.23,23a17.35,17.35,0,0,1,3.17,2.21,2.22,2.22,0,0,0,1-1.34l0-.24a.94.94,0,0,0-.19-.86,1,1,0,0,0-.81-.38h-1a9.13,9.13,0,0,0,.34-1.72v0l.09-2.06v0a2.36,2.36,0,1,1,4.7,0v0l.1,2.06v0A9.32,9.32,0,0,0,34,22.36H33a1,1,0,0,0-1,1.25l0,.24a2.35,2.35,0,0,0,1.3,1.49l1.92.77a2.3,2.3,0,0,1,.77.57,6.85,6.85,0,0,0,.82-2.06,16.06,16.06,0,0,1-1.78,4.5c.19-.34.34-.62.53-1H31.08v2h3.36c.19-.29.38-.62.58-1a16.27,16.27,0,0,1-28,0c.19.34.38.62.58.91h3.36v-2H6.41a9.26,9.26,0,0,0,.53,1,13,13,0,0,1-1.15-2.49.93.93,0,0,1,.43-.43c1.39-.91,3.12-1.92,3.55-2.11a1,1,0,0,0,.72-.72,1,1,0,0,0-.34-1.05,4.63,4.63,0,0,1-1.44-3.5c0-1.72.91-2.88,2.3-2.88s2.3,1.15,2.3,2.88a4.66,4.66,0,0,1-1.49,3.5,1.13,1.13,0,0,0-.38,1,1,1,0,0,0,.67.72,8.87,8.87,0,0,1,1.06.62c.48-.38,1.1-.77,1.82-1.24-.38-.24-.67-.43-1-.58a6.82,6.82,0,0,0,1.2-3.11V17.85a4.31,4.31,0,0,0-4.27-4c-2.49,0-4.32,2.06-4.32,4.84a7.07,7.07,0,0,0,1.2,4c-.62.34-1.49.86-2.73,1.68.1.34.14.67.24,1A16.62,16.62,0,0,1,4.73,21a16.22,16.22,0,0,1,32.44,0,15,15,0,0,1-.34,3.64M21,2A19,19,0,1,0,40,21,19,19,0,0,0,21,2"/>
    </svg>
  `
}

export const IconSun = {
  name: 'icon-sun',
  template: `
    <svg class="icon icon-sun" width="42" height="42" viewBox="0 0 42 42">
      <path d="M21,30.08A9.08,9.08,0,1,1,30.08,21,9.1,9.1,0,0,1,21,30.08M21,9.33A11.67,11.67,0,1,0,32.67,21,11.67,11.67,0,0,0,21,9.33"/>
      <path d="M21,7a1.34,1.34,0,0,0,1.32-1.32V1.32a1.32,1.32,0,1,0-2.64,0V5.68A1.34,1.34,0,0,0,21,7"/>
      <path d="M9.23,11.11a1.36,1.36,0,0,0,.91.41,1.32,1.32,0,0,0,.91-2.23L8,6.19A1.29,1.29,0,0,0,6.14,8Z"/>
      <path d="M7,21a1.34,1.34,0,0,0-1.32-1.32H1.32a1.32,1.32,0,1,0,0,2.64H5.68A1.34,1.34,0,0,0,7,21"/>
      <path d="M9.23,30.89,6.14,34a1.28,1.28,0,0,0,0,1.83,1.36,1.36,0,0,0,.91.41A1.27,1.27,0,0,0,8,35.81l3.09-3.09a1.29,1.29,0,0,0-1.83-1.83"/>
      <path d="M21,35a1.34,1.34,0,0,0-1.32,1.32v4.36a1.32,1.32,0,1,0,2.64,0V36.32A1.34,1.34,0,0,0,21,35"/>
      <path d="M32.77,30.89a1.29,1.29,0,0,0-1.83,1.83L34,35.81a1.37,1.37,0,0,0,.91.41,1.27,1.27,0,0,0,.91-.41,1.28,1.28,0,0,0,0-1.83Z"/>
      <path d="M40.68,19.68H36.32a1.32,1.32,0,1,0,0,2.64h4.36a1.32,1.32,0,0,0,0-2.64"/>
      <path d="M31.8,11.46a1.26,1.26,0,0,0,.91-.41L35.81,8A1.29,1.29,0,1,0,34,6.14L30.89,9.23a1.28,1.28,0,0,0,0,1.83,1.16,1.16,0,0,0,.91.41"/>
      <path d="M24,20.19H21.71c-.15,0-.25-.15-.15-.25l2.08-4.51c.1-.1-.1-.25-.15-.25H19.63a.16.16,0,0,0-.15.15l-1.57,7c0,.15.1.25.15.25h2.08a.16.16,0,0,1,.15.15l-.56,4.77c-.05.25.35.4.45.15l4-7.2c.1-.05,0-.2-.15-.2"/>
    </svg>
  `
}

export const IconPylon = {
  name: 'icon-pylon',
  template: `
    <svg class="icon icon-pylon" width="42" height="42" viewBox="0 0 42 42">
      <path d="M35.77,20.19a1.32,1.32,0,0,0-1.33-1.33H26.12V12.53h4.8v1.25a1.32,1.32,0,0,0,1.33,1.33,1.33,1.33,0,0,0,1.33-1.33V12.53h.87a1.33,1.33,0,0,0,1.33-1.33,1.32,1.32,0,0,0-1.33-1.33H25.58l-3.3-6.12h-.06L22,3.32l-.12-.1a1.2,1.2,0,0,0-.2-.15L21.61,3a1.27,1.27,0,0,0-.24-.08.93.93,0,0,0-.49,0,1.12,1.12,0,0,0-.25,0L20.42,3s0,0,0,0a2,2,0,0,0-.32.24.93.93,0,0,0-.22.27L16.46,9.87H7.56a1.33,1.33,0,0,0-1.33,1.33,1.35,1.35,0,0,0,1.33,1.33h.89v1.25a1.32,1.32,0,0,0,1.33,1.33,1.33,1.33,0,0,0,1.33-1.33V12.53h4.82v6.32H7.56a1.33,1.33,0,0,0-1.33,1.33,1.35,1.35,0,0,0,1.33,1.33h.89v1.25a1.32,1.32,0,0,0,1.33,1.33,1.33,1.33,0,0,0,1.33-1.33V21.52h4L8.79,35l0,.1a2.66,2.66,0,0,0-.28,1.17,2.73,2.73,0,0,0,1,2.08,3.39,3.39,0,0,0,2.14.73,3.07,3.07,0,0,0,1.91-.7L21,32.14l7.42,6.21a3.08,3.08,0,0,0,1.95.73h.09a3.15,3.15,0,0,0,2.06-.75,2.7,2.7,0,0,0,1-2.09,3.07,3.07,0,0,0-.26-1.18L26.88,21.52h4v1.25a1.32,1.32,0,0,0,1.33,1.33,1.33,1.33,0,0,0,1.33-1.33V21.52h.87A1.33,1.33,0,0,0,35.77,20.19ZM21,7l1.56,2.86H19.48Zm-2.41,5.52h4.87v6.32H18.59Zm-6.8,23.9h-.68l.19-.5,4-8.58,3.63,3Zm4.71-11.56L18,21.52H24l1.58,3.38L21,28.66ZM30.94,36.39h-.7l-7.11-6,3.58-3Z"/>
    </svg>
  `
}



// WEBPACK FOOTER //
// ./src/components/standard/my-icons.js